export interface AnnouncementAuthorJSON {
  id?: string | null
  first_name?: string | null
  last_name?: string | null
  full_name?: string | null
  name?: string | null
  role?: string | null
  email?: string | null
  avatar?: string | null
}

export interface AnnouncementJSON {
  id: string
  title?: string | null
  content?: string | null
  course_id?: string | null
  course?: {
    id?: string | null
    title?: string | null
    code?: string | null
  } | null
  course_title?: string | null
  programme_id?: string | null
  programme?: {
    id?: string | null
    title?: string | null
  } | null
  programme_title?: string | null
  author_id?: string | null
  author?: AnnouncementAuthorJSON | null
  author_name?: string | null
  author_role?: string | null
  is_pinned?: boolean | null
  is_active?: boolean | null
  created_at?: string | null
  updated_at?: string | null
  isPinned?: boolean | null
  isActive?: boolean | null
  createdAt?: string | null
  updatedAt?: string | null
}

export class AnnouncementModel {
  readonly id: string
  readonly title: string
  readonly content: string
  readonly courseId?: string | null
  readonly courseTitle?: string | null
  readonly programmeId?: string | null
  readonly programmeTitle?: string | null
  readonly authorId?: string | null
  readonly authorName?: string | null
  readonly authorRole?: string | null
  readonly authorEmail?: string | null
  readonly authorAvatar?: string | null
  readonly isPinned: boolean
  readonly isActive: boolean
  readonly createdAt?: string | null
  readonly updatedAt?: string | null

  constructor(options: {
    id: string
    title: string
    content: string
    courseId?: string | null
    courseTitle?: string | null
    programmeId?: string | null
    programmeTitle?: string | null
    authorId?: string | null
    authorName?: string | null
    authorRole?: string | null
    authorEmail?: string | null
    authorAvatar?: string | null
    isPinned?: boolean
    isActive?: boolean
    createdAt?: string | null
    updatedAt?: string | null
  }) {
    this.id = options.id
    this.title = options.title
    this.content = options.content
    this.courseId = options.courseId
    this.courseTitle = options.courseTitle
    this.programmeId = options.programmeId
    this.programmeTitle = options.programmeTitle
    this.authorId = options.authorId
    this.authorName = options.authorName
    this.authorRole = options.authorRole
    this.authorEmail = options.authorEmail
    this.authorAvatar = options.authorAvatar
    this.isPinned = Boolean(options.isPinned)
    this.isActive = options.isActive ?? true
    this.createdAt = options.createdAt
    this.updatedAt = options.updatedAt
  }

  static fromJSON(json: AnnouncementJSON): AnnouncementModel {
    const title = json.title ?? ''
    const content = json.content ?? ''

    const author = json.author ?? null
    const combinedName = [author?.first_name, author?.last_name].filter(Boolean).join(' ')
    const authorName =
      json.author_name ??
      author?.full_name ??
      author?.name ??
      (combinedName ? combinedName : null)

    return new AnnouncementModel({
      id: json.id,
      title,
      content,
      courseId: json.course_id ?? json.course?.id ?? null,
      courseTitle: json.course_title ?? json.course?.title ?? null,
      programmeId: json.programme_id ?? json.programme?.id ?? null,
      programmeTitle: json.programme_title ?? json.programme?.title ?? null,
      authorId: json.author_id ?? author?.id ?? null,
      authorName,
      authorRole: json.author_role ?? author?.role ?? null,
      authorEmail: author?.email ?? null,
      authorAvatar: author?.avatar ?? null,
      isPinned: json.is_pinned ?? json.isPinned ?? false,
      isActive: json.is_active ?? json.isActive ?? true,
      createdAt: json.created_at ?? json.createdAt ?? null,
      updatedAt: json.updated_at ?? json.updatedAt ?? null,
    })
  }
}
